export default [
  { name: 'Intro', fee: 750, fullname: 'Search Advertising Intro', code: 'searchIntro' },
  { name: 'Starter', fee: 1000, fullname: 'Search Advertising Starter', code: 'searchStarter' },
  { name: 'Plus', fee: 1500, fullname: 'Search Advertising Plus', code: 'searchPlus' },
  { name: 'Advanced', fee: 2000, fullname: 'Search Advertising Advanced', code: 'searchAdvanced' },
  { name: 'Other', fee: null, fullname: 'Search Advertising Other', code: 'searchOther' }
]



// WEBPACK FOOTER //
// ./src/data/searchAdvertisingItems.js